const FormCodeEnum = {
    DEFAULT: 400,
    SEND_TO_LOGIN: 405    
}

export default FormCodeEnum;